import { Button } from 'components/button';
import { TextField } from 'components/input';
import { ModalComponent } from 'components/modal';
import {
  useFetchKitchenPlanningDataByBranch,
  useFetchKitchenPlanningDataByBrand
} from 'hooks/kitchenPlanning/useKitchenPlanningHook';
import React, { useEffect, useState } from 'react';
import { useStore } from 'store';
import Stockitem from 'components/kitchenplanning/stockitem';
import Toprepare from 'components/kitchenplanning/toprepare';
import Foodwaste from 'components/kitchenplanning/foodwaste';

import styles from './index.module.css';
import { Column, Row } from 'layouts/container';
import { Ikon } from 'assets/icons';
import PreparedStockSlider from './preparedStockSlider';

export default function KitchenPlanning() {
  const { branch } = useStore((state) => state);

  const {
    data = [],
    isLoading,
    refetch
  } = useFetchKitchenPlanningDataByBranch(branch?.id);
  console.log('lll', data);
  const {
    toPrepareRecipes = [],
    toPrepareMixtures = [],
    expiringMixtures = [],
    expiringProducts = [],
    expiringRecipes = []
  } = data;
  const [search, setSearch] = useState('');

  // aply discount
  const [applyDiscountModal, setApplyDiscountModal] = useState(false);
  const [appliedDiscountType, setAppliedDiscountType] = useState('Flat');
  const [disountPercentage, setDisountPercentage] = useState('');
  const [startDiscountPercentage, setStartDiscountPercentage] = useState('');
  const [endDiscountPercentage, setEndDiscountPercentage] = useState('');

  // new batch
  const [newBatchModal, setNewBatchModal] = useState(false);
  const [foodItems, setfoodItems] = useState([]);
  const [selectedFoodItem, setSelectedFoodItem] = useState({});
  const [numberOfServings, setNumberOfServings] = useState('');
  const [expiryDate, setexpiryDate] = useState('');
  const [applyDiscountToBatch, setApplyDiscountToBatch] = useState(false);
  const [newBatchDiscountType, setNewBatchDiscountType] = useState('Flat');
  const [newBatchDiscountPercentage, setNewBatchDiscountPercentage] =
    useState('');
  const [newBatchStartDiscountPercentage, setNewBatchStartDiscountPercentage] =
    useState('');
  const [newBatchEndDiscountPercentage, setNewBatchEndDiscountPercentage] =
    useState('');

  // override prediction

  const onCloseApplyDiscountModal = () => {
    setDisountPercentage('');
    setStartDiscountPercentage('');
    setEndDiscountPercentage('');
    setAppliedDiscountType('Flat');
    setApplyDiscountModal(false);
  };

  const onCloseNewBatchModal = () => {
    setNewBatchModal(false);
    setSelectedFoodItem({});
    setNumberOfServings('');
    setexpiryDate('');
    setApplyDiscountToBatch(false);
    setNewBatchDiscountType('Flat');
    setNewBatchDiscountPercentage('');
    setNewBatchStartDiscountPercentage('');
    setNewBatchEndDiscountPercentage('');
  };

  // TODO change this function
  const onApplyDiscount = () => {
    onCloseApplyDiscountModal();
  };

  // TODO change this function
  const onApplyNewBatch = () => {
    onCloseNewBatchModal();
  };

  // TODO change this function

  if (isLoading) {
    return <h1>Loading</h1>;
  }

  return (
    <Column padding={'30px 0'} gap={30}>
      <Row gap={16}>
        <Column gap={5}>
          <h2 className={styles.h2}>Kitchen Planning</h2>
          <p className={styles.p}>We hope you're having a good day.</p>
        </Column>
        <Button
          onClick={() => {}}
          style={{
            gap: 6,
            background: '#D5D5DC',
            padding: '10px 15px',
            borderRadius: 6,
            fontWeight: '400',
            fontSize: 14,
            color: '#16192C'
          }}
        >
          <Ikon name={'export'} />
          Export
        </Button>
      </Row>
      <Column
        gap={21}
        padding={'0'}
        style={{
          background: '#FFFFFF',
          border: '#EDF2F7 1px solid',
          borderRadius: 10,
          boxShadow: '0px 3px 8px -1px #3232470D, 0px 0px 1px 0px #0C1A4B3D'
        }}
      >
        <Row gap={15} alignItems={'flex-start'}>
          <Column
            gap={24}
            padding={'24px 20px'}
            style={{ maxWidth: 'calc(100% - 388px)', flex: 1 }}
          >
            <Column gap={20}>
              <div className={styles.title_1}>Prepared items in stock</div>
              <div style={{ width: '100%', overflow: 'hidden' }}>
                <PreparedStockSlider />
              </div>
            </Column>
            <Column gap={20}>
              <h4 className={styles.title_2}>Demand Forecasting</h4>
              <Row gap={20}>
                <Column gap={'0'}></Column>
              </Row>
            </Column>
          </Column>
          <Column
            gap={24}
            padding={'24px 20px'}
            width={373}
            style={{ borderLeft: '#EBEBEB 1px solid' }}
          >
            <h4 className={styles.title_2}>Alerts!</h4>
          </Column>
        </Row>
      </Column>

      <Stockitem search={search} setSearch={setSearch} />
      <Toprepare
        toPrepareMixtures={toPrepareMixtures}
        toPrepareRecipes={toPrepareRecipes}
        newBatchModal={newBatchModal}
        setNewBatchModal={setNewBatchModal}
        refetch={refetch}
      />

      <Foodwaste
        expiringMixtures={expiringMixtures}
        expiringProducts={expiringProducts}
        expiringRecipes={expiringRecipes}
        setNewBatchModal={setNewBatchModal}
        refetch={refetch}
      />
    </Column>
  );
}
